// src/ApiContext.tsx
import React, { createContext, ReactNode, useContext } from 'react';
import apiClient from './apiClient';

interface ApiContextProps {
  client: typeof apiClient;
  submitForm: () => Promise<void>;
}

const ApiContext = createContext<ApiContextProps | undefined>(undefined);

export const useApi = () => {
  const context = useContext(ApiContext);
  if (!context) {
    throw new Error('useApi must be used within an ApiProvider');
  }
  return context;
};

interface ApiProviderProps {
  children: ReactNode;
  api: ApiContextProps;
}

export const ApiProvider: React.FC<ApiProviderProps> = ({ children, api }) => {
  return <ApiContext.Provider value={api}>{children}</ApiContext.Provider>;
};
